
interface ShrinkWrapLabelProps {
  /** Label text */
  text: string;
  /** Font string for pretext measurement */
  font?: string;
  /** Additional className */
  className?: string;
}

/**
 * A label that shrink-wraps to its exact text width using pretext.
 * Falls back to standard inline-flex layout when pretext is unavailable.
 *
 * Approved use cases (doc 04):
 * - Trust labels
 * - Proof chips
 * - Winner rationale tags
 */
export function ShrinkWrapLabel({ text, className = '' }: ShrinkWrapLabelProps) {
  // Pretext shrinkwrap measurement is deferred to when specific
  // layout integrations need it (e.g., share cards, editorial layouts).
  // For standard UI labels, CSS inline-flex is the correct fallback.

  return (
    <span
      className={`inline-flex items-center rounded-pill border border-border-soft bg-surface/60 px-3 py-1.5 text-xs text-ink-muted font-ui whitespace-nowrap ${className}`}
    >
      {text}
    </span>
  );
}
